import { cn } from '@/lib/utils';
import { STATUS_LABELS, type MachineStatus } from '@/lib/machineStatus';

const PILL: Record<MachineStatus, string> = {
  running: 'bg-status-running/10 text-status-running',
  ready: 'bg-status-ready/10 text-status-ready',
  blocked: 'bg-status-blocked/10 text-status-blocked',
  off: 'bg-status-off/15 text-status-off',
};

const DOT: Record<MachineStatus, string> = {
  running: 'bg-status-running',
  ready: 'bg-status-ready',
  blocked: 'bg-status-blocked',
  off: 'bg-status-off',
};

interface Props {
  status: MachineStatus;
  className?: string;
  size?: 'sm' | 'md';
  showDot?: boolean;
}

export function StatusBadge({ status, className, size = 'sm', showDot = false }: Props) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full font-semibold',
        size === 'sm' ? 'px-2.5 py-1 text-xs' : 'px-3 py-1.5 text-sm',
        PILL[status],
        className,
      )}
    >
      {showDot && <span className={cn('rounded-full', DOT[status], 'h-1.5 w-1.5')} />}
      {STATUS_LABELS[status]}
    </span>
  );
}
